import React, { useState, useEffect } from 'react';
import { optimizedImage } from '../imageUrl';
import '../style/card.css';

function getYear(releaseDate) {
  if (!releaseDate) return '';
  return releaseDate.toString().slice(0, 4);
}

function FeaturedCard({ film, image, imagexs, onCardClick }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!film) return null;

  const bgImage = optimizedImage(isMobile ? (imagexs || image) : image, 1400);
  const year = getYear(film.releaseDate);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onCardClick(film);
    }
  };

  return (
    <div
      className="bb-featured"
      onClick={() => onCardClick(film)}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Ouvrir ${film.title}`}
    >
      <div className="bb-featured__text">
        <span className="bb-featured__kicker bb-meta">À la une</span>
        <h2 className="bb-featured__title bb-display">{film.title}</h2>
        <div className="bb-featured__meta">
          {year && <span className="bb-pill bb-meta">{year}</span>}
          {film.duration && <span className="bb-pill bb-meta">{film.duration}</span>}
        </div>
        <span className="bb-btn bb-btn--primary" aria-hidden="true">▶ Lecture</span>
      </div>
      <div className="bb-featured__frame">
        <div className="bb-featured__poster" style={{ backgroundImage: `url(${bgImage})` }} />
      </div>
    </div>
  );
}

export default FeaturedCard;
